import {stringToHTML} from '../helper';

export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('label');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,
            name:"C-QUESTION-TEXT",
            "custom-name":"C-QUESTION-TEXT",
            droppable: false,
            draggable:false,
            removable:false,
            copyable:false,
            toolbar:[],
            attributes:{
                'data-slg-type':'C-QUESTION-TEXT',
            },
            /* components:[
                {
                    type: 'text',
                    name:"C-QUESTION-TEXT",
                    droppable: false,
                    draggable:false,
                    badgable:false,
                    removable:false,
                    copyable:false,
                    content: 'What is your question?',
                }
            ] */
            content:"What is your question?"
        },
        setContent:function(content){
            /* if(this.hasTextnode()){
                this.components().at(0).components().at(0).set('content',"");
            }
            this.components().at(0).set('content',text); */
            let component = this;
            component.set('content',content);
        },
        getContent:function() {
            /* let text_content = this.components().at(0).get('content');
            if(text_content && text_content != ""){
                // return stringToHTML(text_content).innerText.trim();
                return text_content.trim();
            }else{
                let textnode_content = this.components().at(0).components().at(0).get('content');
                //return stringToHTML(textnode_content).innerText.trim(); 
                return textnode_content.trim();
            } */
            let component = this;
            return component.get('content').trim();
                
        },
        hasTextnode(){
            let component = this;
            if(component.components().at(0).components().length > 0){
                return true;
            }
            return false;
        }
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-QUESTION-TEXT")
                return { type:'C-QUESTION-TEXT' }
        }
    });

    var view = VIEW.extend({
        tagName:"div",
        onRender() {
            this.el.style.display = "inline-block";
        },
    });

    DOMC.addType('C-QUESTION-TEXT', {
        model,
        view,
    });
};
  